import { PersistConfig } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage
import { RootState } from './types';
import { baseApi } from './baseApi';
import { createScopedStorage } from './scopedStorage';

// Create scoped storage for root persistence
const scopedStorage = createScopedStorage(storage);

// Dynamic whitelist for persisted feature slices
// Features using nested persistence don't need to be in the root whitelist
const dynamicWhitelist: string[] = [];

// Root level persistence configuration
export const persistConfig: PersistConfig<RootState> = {
  key: 'root',
  storage: scopedStorage,
  // Blacklist API cache, UI state, and feature registry (non-persistent by design)
  blacklist: ['ui', baseApi.reducerPath, 'featureRegistry'],
  // Dynamic whitelist - will be populated as features register
  whitelist: dynamicWhitelist,
  // Enable debugging in development
  debug: process.env.NODE_ENV !== 'production',
};

/**
 * Add a feature slice to the persistence whitelist
 */
export function addToWhitelist(sliceName: string) {
  if (!dynamicWhitelist.includes(sliceName)) {
    dynamicWhitelist.push(sliceName);
    console.log(`✅ Added ${sliceName} to persistence whitelist. Current whitelist:`, [
      ...dynamicWhitelist,
    ]);
    console.log(`📋 Root persist config whitelist now includes:`, persistConfig.whitelist);
  } else {
    console.log(`⚠️ ${sliceName} already in whitelist`);
  }
}

/**
 * Remove a feature slice from the persistence whitelist
 */
export function removeFromWhitelist(sliceName: string) {
  const index = dynamicWhitelist.indexOf(sliceName);
  if (index !== -1) {
    dynamicWhitelist.splice(index, 1);
    console.log(
      `Removed ${sliceName} from persistence whitelist. Current whitelist:`,
      dynamicWhitelist,
    );
  }
}
